import * as yup from "yup";
import {startOfToday, endOfToday} from "date-fns";

const schemaBookingItems = yup.array().of(
        yup.object().shape({
            price: yup.number()
                .nullable()
                .positive('Deve essere un numero positivo')
                .typeError('Deve essere un numero'),
        })
        )
        .typeError('Campo non valido')
        .min(1, 'Devi selezionare almeno un elemento');

export const schemaStepGuest = yup.object().shape({
    name: yup
        .string()
        .nullable()
        .typeError('Deve essere in formato testuale'),
    surname: yup
        .string()
        .nullable()
        .typeError('Deve essere in formato testuale'),
    email: yup
        .string()
        .nullable()
        .email('Deve essere un indirizzo email valido'),
    nationality: yup
        .string()
        .nullable()
        .typeError('Deve essere in formato testuale'),
});

export const schemaStepBooking = yup.object().shape({
    bookingItems: schemaBookingItems,
    arrival: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa')
        .required('Campo obbligatorio'),
    departure: yup
        .date()
        .typeError('Deve essere una data valida gg/mm/aaaa\'')
        .min(startOfToday(), 'Deve essere maggiore o uguale alla data di oggi')
        .test(
            'al-least-one-night',
            'Deve essere maggiore rispetto alla data di arrivo',
            (value, testContext) => {
                const {arrival} = testContext.parent;
                return value > arrival
            }
        )
        .test(
            'at-most-2-months',
            'Durata soggiorno deve essere minore o uguale a 2 mesi',
            (value, testContext) => {
                const {arrival} = testContext.parent;
                return value <= new Date(arrival).setMonth(new Date(arrival).getMonth() + 2)
            }
        )
        .required('Campo obbligatorio'),
    adults: yup
        .number()
        .positive('Deve essere un numero positivo')
        .integer('Deve essere un numero intero')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
    children: yup
        .number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
    petsNumber: yup
        .number()
        .integer('Deve essere un numero intero')
        .min(0, 'Deve essere maggiore o uguale a 0')
        .max(5, 'Deve essere minore o uguale a 5')
        .typeError('Deve essere un numero')
        .required('Campo obbligatorio'),
});

export const schemaStepAmount = yup.object().shape({
    bookingItems: schemaBookingItems,
    depositPayed: yup
        .boolean(),
    deposit: yup
        .number()
        .nullable()
        .positive('Deve essere un numero positivo')
        .typeError('Deve essere un numero')
        .when('depositPayed', {
            is: true,
            then: yup
                .number()
                .nullable()
                .required('Campo obbligatorio')
        })
        .test(
            'deposit-less-than-total',
            "Deve essere minore o uguale rispetto all'importo totale",
            (value, testContext) => {
                const totalPrice = testContext.parent.bookingItems.reduce(
                    (acc, x) => {
                        const price = x.price || 0;
                        return acc + price;
                    }, 0);
                return !totalPrice || !value || value <= totalPrice
            }
        ),
    depositPayedAt: yup
        .mixed()
        .when('depositPayed', {
            is: true,
            then: yup
                .date()
                .typeError('Deve essere una data valida gg/mm/aaaa')
                .max(endOfToday(), 'Deve essere minore o uguale alla data di oggi')
                .required('Campo obbligatorio')
        }),
    depositPaymentType: yup
        .mixed()
        .when('depositPayed', {
            is: true,
            then: yup
                .string()
                .typeError('Campo non valido')
                .required('Campo obbligatorio'),
        })
});


export const schemaStepBookingCondition = yup.object().shape({
    bookingCondition: yup.object().shape({
        cancellationPolicy: yup
            .string()
            .typeError('Campo non valido')
            .required('Campo obbligatorio'),
        refundableUntil: yup
            .mixed()
            .when('cancellationPolicy', {
                is: (val) => val === 'time_restricted_refundable',
                then: yup
                    .date()
                    .min(startOfToday(), 'Deve essere maggiore o uguale alla data di oggi')
                    .max(yup.ref('$arrival'), 'Deve essere minore o uguale alla data di arrivo')
                    .typeError('Deve essere una data valida gg/mm/aaaa')
                    .required('Campo obbligatorio'),
                otherwise: yup.mixed().nullable()
            }),
        touristTaxPolicy: yup
            .string()
            .typeError('Campo non valido')
            .required('Campo obbligatorio'),
        touristTaxUnitPrice: yup
            .number()
            .nullable()
            .when('touristTaxPolicy', {
                is: (val) => val === 'included' || val === 'excluded',
                then: yup
                    .number()
                    .typeError('Deve essere un numero')
                    .positive('Deve essere un numero positivo')
                    .required('Campo obbligatorio'),
                otherwise: yup.number().nullable()
            }),
        checkInFrom: yup
            .mixed()
            .nullable(),
        checkOutBefore: yup
            .mixed()
            .nullable(),
    })
});

export const schemaBooking = [schemaStepBooking, schemaStepGuest, schemaStepAmount, schemaStepBookingCondition].reduce((acc, x) => acc.concat(x));